import { Shield, Award, Users, Clock, Star, CheckCircle } from 'lucide-react';

export default function TrustSection() {
  const trustElements = [
    {
      icon: Shield,
      title: "Paiement Sécurisé",
      description: "SSL 256-bit, cartes acceptées",
      badge: "100% sécurisé"
    },
    {
      icon: Award,
      title: "Certifié Qualité",
      description: "Licence officielle Dubai Tourism",
      badge: "Certifié"
    },
    {
      icon: Users,
      title: "+100k Clients",
      description: "Satisfaits depuis 2014",
      badge: "Référence"
    },
    {
      icon: Clock,
      title: "Support 7j/7",
      description: "Équipe française à Dubai",
      badge: "Disponible"
    }
  ];

  const guarantees = [
    "✓ Meilleur prix garanti ou remboursement de la différence",
    "✓ Annulation gratuite jusqu'à 24h avant",
    "✓ Confirmation instantanée par email et SMS",
    "✓ Support client en français 7j/7",
    "✓ Activités testées et approuvées par notre équipe",
    "✓ Assurance voyage incluse sur toutes nos prestations"
  ];

  const testimonialStats = [
    { value: "4.9/5", label: "Note moyenne", icon: Star },
    { value: "98%", label: "Clients satisfaits", icon: CheckCircle },
    { value: "2847", label: "Avis vérifiés", icon: Users },
    { value: "24h", label: "Réponse garantie", icon: Clock }
  ];

  return (
    <section className="py-20 bg-blue-900 text-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Pourquoi Nous Faire <span className="text-amber-400">Confiance ?</span>
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Plus de 10 ans d'expérience à Dubai, une équipe française dédiée, 
            et des milliers de clients satisfaits font de nous votre partenaire de confiance.
          </p>
        </div>

        {/* Trust elements grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {trustElements.map((element, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-amber-400 rounded-full flex items-center justify-center mx-auto group-hover:scale-110 transition-transform duration-300">
                  <element.icon size={32} className="text-blue-900" />
                </div>
                <span className="absolute -top-2 -right-2 bg-green-500 text-white text-xs px-2 py-1 rounded-full font-semibold">
                  {element.badge}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-2">{element.title}</h3>
              <p className="text-blue-200">{element.description}</p>
            </div>
          ))}
        </div>

        {/* Guarantees section */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-16">
          <h3 className="text-2xl font-bold text-center mb-8 text-amber-400">
            Nos Garanties
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {guarantees.map((guarantee, index) => (
              <div key={index} className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <CheckCircle size={16} className="text-white" />
                </div>
                <span className="text-blue-100">{guarantee.replace('✓ ', '')}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonialStats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center mb-3">
                <stat.icon size={24} className="text-amber-400 mr-2" />
                <span className="text-3xl lg:text-4xl font-bold text-amber-400">
                  {stat.value}
                </span>
              </div>
              <p className="text-blue-200">{stat.label}</p>
            </div>
          ))}
        </div>

        {/* Security badges */}
        <div className="flex justify-center items-center space-x-8 mt-16 pt-8 border-t border-blue-800">
          <div className="flex items-center space-x-2">
            <img 
              src="https://mesvacancesadubai.com/wp-content/uploads/2024/11/card.png" 
              alt="Cartes acceptées" 
              className="h-8"
            />
            <span className="text-sm text-blue-200">Paiement sécurisé</span>
          </div>
          <div className="flex items-center space-x-2">
            <Shield size={20} className="text-green-400" />
            <span className="text-sm text-blue-200">SSL Certifié</span>
          </div>
          <div className="flex items-center space-x-2">
            <Award size={20} className="text-amber-400" />
            <span className="text-sm text-blue-200">Licence Dubai Tourism</span>
          </div>
        </div>
      </div>
    </section>
  );
}